import React, { Component } from "react"
import Floaty from '../../../components/Floaty'
import DownArrows from '../../../components/DownArrows'
import styles from "./styles.css"
import logo from "./logo.png"

class Feature extends Component {
  constructor(props) {
    super(props);

    this.state = {
      parentHeight: 760,
      parentWidth: 1280
    }
  }

  updateParentDimenions() {
    this.setState({
      parentHeight: this.feature.clientHeight,
      parentWidth: this.feature.clientWidth
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateParentDimenions.bind(this))

    this.updateParentDimenions()
  }

  render() {
    return (
      <div className='feature' ref={(feature) => this.feature = feature}>
        <Floaty class='logo' parentHeight={this.state.parentHeight} parentWidth={this.state.parentWidth} img={logo} />

        <div className='feature__down-arrows'>
          <DownArrows amount='1' />
        </div>
      </div>
    )
  }
}

export default Feature;



// WEBPACK FOOTER //
// ./src/parts/home/Feature/index.js